// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-tab-active":"Ycj68","packingGroup":"A0Gpc","packingGroup-title":"OBgGn","packingGroup-items":"FVabT"};